export default {
      id: "icon-copy-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.svg#icon-copy",
      toString: function () {
        return this.url;
      }
    }